export const COMPONENT_DELAY_MS = 50